type MaybePromise<T> = Promise<T> | T

export function asyncPipe<A, B>(ab: (a: A) => MaybePromise<B>): (a: MaybePromise<A>) => Promise<B>
export function asyncPipe<A, B, C>(
  ab: (a: A) => MaybePromise<B>,
  bc: (b: B) => MaybePromise<C>,
): (a: MaybePromise<A>) => Promise<C>
export function asyncPipe(...fns: Function[]) {
  return (x: any) => fns.reduce(async (y, fn) => fn(await y), x)
}

export const pipe =
  (...fns: CallableFunction[]) =>
  (x: any) =>
    fns.reduce((y, f) => f(y), x)

export const trace =
  <T, X>(message: string, func: (i: T) => X) =>
  (input: T): X => {
    const output = func(input)
    console.log(message + " Input: ", input)
    console.log(message + " Output: ", output)
    return output
  }

export const log =
  (msg: string) =>
  <T>(other: T): T => {
    console.log(msg, " ", other)

    return other
  }
